import Mutations from '../../odata/mutations';

export default { ...new Mutations('completedTask'), ...new Mutations('completedTasks') };
